module.exports = __webpack_public_path__ + "img/km9.2aeb48c0.jpg";